<div class="select-client-bar">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="select-client-field">
    <!-- Disabled when there are no clients -->
    <mat-select
      [(value)]="selectedCustomer"
      panelClass="select-client-panel"
      [disabled]="!hasCustomers"
      [attr.aria-label]="'SELECT_CLIENT' | translate"
      placeholder="{{ (hasCustomers ? 'SELECT_CLIENT' : 'NO_CLIENTS_AVAILABLE') | translate }}">
      <mat-select-trigger>
        <span class="select-client-trigger">
          <span class="select-client-name">{{ selectedCustomer?.customerName }}</span>
          <span class="select-client-id">{{ selectedCustomer?.customerId }}</span>
        </span>
      </mat-select-trigger>
      @for (customer of customerSelectionData?.customers; track customer) {
        <mat-option [value]="customer" class="hideMatOptionCheckbox">
          <span class="select-client-option">
            <span class="select-client-name">{{ customer.customerName }}</span>
            <span class="select-client-id">{{ customer.customerId }}</span>
          </span>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button
    type="button"
    class="btn btn-primary shadow-sm"
    [disabled]="!selectedCustomer"
    (click)="loginIntoCustomer()"
    >
    {{ "CHANGE_CUSTOMER" | translate }}
    <span class="ml-1"
      ><i class="fa-light fa-arrow-right-to-bracket"></i
    ></span>
  </button>
</div>
<router-outlet></router-outlet>
